// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__2CIF5","disabled":"FileBtn_disabled__14b53","warn":"FileBtn_warn__yUWTY","fade":"FileBtn_fade__35s0a"};